import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const accountApi = createApi({
  reducerPath: 'accountApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Account'],
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => ({ url: '/accounts/me', method: 'GET' }),
      providesTags: ['Account'],
    }),

    updateAccountPreference: builder.mutation({
      query: ({ preference }) => ({
        url: '/internal/v1/accounts/preferences',
        method: 'PATCH',
        data: { enable_pass_template_builder: preference },
      }),
      invalidatesTags: ['Account'],
    }),
  }),
});

export const { useGetMeQuery, useUpdateAccountPreferenceMutation } = accountApi;
